import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

import styled from 'styled-components';

const Wrapper = styled.h5`
  font-size: inherit;
  line-height: inherit;
`;

export const H5 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '18px', lineHeight: '24px' },
    { fontSize: '24px', lineHeight: '36px' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      <Wrapper>{children}</Wrapper>
    </BaseText>
  );
};
